import { Outlet } from 'react-router-dom';

const MobileAppLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default MobileAppLayout;
